import React from 'react';
import styled from 'styled-components';

import EnhancedTable from './EnhancedTable';

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;
  padding: 5px;

  .enhanced-table {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .scroll {
    display: inline-grid;
  }
`;

const UsersTableView = ({ tableConfig, className = '' }) => (
  <StyledDiv
    className={className}
    style={{
      height: '100%',
      width: '100%',
    }}
  >
    <EnhancedTable
      className="enhanced-table"
      data={tableConfig.rows}
      columns={tableConfig.columns}
      pivotBy={tableConfig.pivotBy}
      defaultPageSize={20}
      pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
      // style={{padding: '20px'}}
    />
  </StyledDiv>
);

export default UsersTableView;
